<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Header({
              text: 'Koncerty'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['text_pl']),
                fields: [
                  new fields.Input({
                    label: 'Tekst',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'text'],
                    multilingual: true
                  }),
                  new fields.Input({
                    label: 'Tekst tła',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'bg_text'],
                    multilingual: true
                  }),
                  new fields.Link({
                    label: 'Odnośnik',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'link'],
                    hideLinkLabel: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
